import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cipo-not-found',
  imports: [FlexLayoutModule, TranslateModule, MatIconModule],
  template: `
    <div fxLayout="column" fxLayoutAlign="center center" data-testid="cipo-not-found"> 
      <p class="cipo-text--regular-lg">{{ title() | translate }}</p>
      <p>{{ description() | translate }}</p>
      @if (icon()) {
        <mat-icon class="cipo-icon material-symbols-outlined cipo-icon--xl m-t-xl" color="warn">{{ icon() }}</mat-icon>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  title = input('notFound.nothingFound');
  description = input<string>();
  icon = input<string>('search_off');
}
